<app-error-code code="403" [title]="'Permission denied!'"
    [message]="'You do not have permission to access the requested data.'"></app-error-code>